import { Box } from '@material-ui/core';
import React from 'react';
import { useWindowDimension } from '../../../../hooks/windowDimensions';
import { getHelpServices } from './helpCentre.util';
import HelpServices from './HelpServices';
import HelpServicesMobile from './HelpServicesMobile';
import styles from './style';

/**
 * @name HelpCentreServicesContainer
 * @param {*} props - react props
 * @returns {JSX.Element} - Renders Help centre services component
 */
const HelpCentreServicesContainer = () => {
    const classes = styles();
    const [width] = useWindowDimension();
    const servicesInfo = getHelpServices();
    return (
        <>
            <Box className={classes.helpCentreContainer}>
                {width < 600 ? (
                    <Box className={classes.mobileContainer}>
                        {servicesInfo?.map(service => (
                            <HelpServicesMobile {...service} />
                        ))}
                    </Box>
                ) : (
                    <Box className={classes.desktopContainer}>
                        <HelpServices services={servicesInfo} />
                    </Box>
                )}
            </Box>
        </>
    );
};

export default HelpCentreServicesContainer;
